import styled  from 'styled-components';
import { Color } from 'styles';

export const StyledWrapper = styled.section`
  align-items: center;
  background-color: ${Color.Black};
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  position: relative;
`;


// WEBPACK FOOTER //
// ./src/components/hero/hero.style.js